/* tslint:disable:max-line-length component-class-suffix */

import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { uniqBy, isNil } from 'lodash';
import {
  SetSharedDataAction
} from '../../../store/actions/shared-data.action';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
import { ProductPayment } from '../../../../lib/angular/model/protectionproduct/payment';
import { Product } from '../../../../lib/angular/model/protectionproduct/product';
import { DDMenuEnableDisableService } from '../../../shared/service/common/dd-menu-enable-disable.service';
// Store
//
import { Store } from '@ngrx/store';
import {
  IAppState,
  SharedDataStore, ProtectionProductStore
} from '../../../store/index';
import { environment } from '../../../../environments/environment.prod';
import { DealerDetailService } from '../../../services/api/dealer-detail.service';
import { OmnitureTags } from 'src/app/shared/omnitureTags';
import {
  MenuActionSetActive
} from '../../../store/actions/menu.action';

@Component({
  providers: [OmnitureTags],
  selector: 'dd-v-spec-protection-product',
  templateUrl: './v-spec-protection-products.html',
  styleUrls: ['./v-spec-protection-products.scss']
})

export class VSpecProtectionProducts implements OnInit, AfterViewInit, OnDestroy {

  //
  // Public
  //
  public vehicle: Vehicle;
  public paymentType: string = "";
  public productPayment: ProductPayment;
  public shared: any;
  public dealers: any;
  public salesClass: any;
  public plan = new Array<any>();
  dealerDetails: any;
  dealerCd: string;
  public filteredProducts = new Array<Product>();

  ngAfterContentInit() {

  }
  ngAfterViewInit() {
    if(!isNil(this._route.snapshot.paramMap.get("index")))
    {
     let index="divtoScroll"+this._route.snapshot.paramMap.get("index")
      var elmnt = document.getElementById(index);
      if(!isNil(elmnt))
      elmnt.scrollIntoView();
    } 
    let product:any  = document.getElementsByClassName("product");
    let monthly:any  = document.getElementsByClassName("monthly");
    let description:any  = document.getElementsByClassName("description"); 
    if(!isNil(monthly)  && !isNil(description) && !isNil(product))
    {
      for (let i = 0; i < product.length; i++) {
        if(!isNil(product[i]) &&  product[i].offsetHeight>22)
        {
        product[i].style.marginTop = '-12px';
        product[i].style.marginBottom = '-8px';
        }
        if(!isNil(monthly[i])  &&  product[i].offsetHeight>22)
        {
          monthly[i].style.marginTop = '6px';
        }
        if(!isNil(description[i])  &&  product[i].offsetHeight>22)
        {
        description[i].style.marginBottom = '6px';
        description[i].style.marginTop = '11px';
        }
      }   
    }
  }
  //
  // OnInit
  //
  ngOnInit() {
    //
    // Get access to the parent data
    //
    this._route.parent.data.subscribe((params: any) => {
      //
      // Get Vehicle Information
      //
      this.vehicle = params['data'];

      //
      // Listen for Shared Data
      //
      this._store.select(SharedDataStore).subscribe(data => {
        this.shared = Object.assign({}, data, {
          vehicleDetails: this.vehicle,
          currentVin: this.vehicle.vin
        });
      });

      //
      // Save Shared Data
      //
      this._store.dispatch(new SetSharedDataAction(this.shared));
      this._ddMenuEnableDisableService.loadFeatureConfigData(this.vehicle);
      this._ddMenuEnableDisableService.loadProtectionProducts(this.shared);
      this._store.dispatch(new MenuActionSetActive(<any>{ label: 'Protection Products' }));
      this.loadPaymentDetails(this.shared);

    });

    this.route.parent.params.subscribe(params => {
      this.dealerCd = params['dealerCd'];
      });
    this.getDealerDetails();
  
  }
  loadPaymentDetails(sharedData: any) {
    let self = this;
    let tfsFilteredFinancingArray = [];


    if (sharedData.token && sharedData.tfsFinancingArray.length > 0) {
      tfsFilteredFinancingArray = sharedData.tfsFinancingArray.filter(function (item) {
        return item.vin == sharedData.currentVin;
      });
      if (tfsFilteredFinancingArray.length > 0) {
        this.productPayment = new ProductPayment(tfsFilteredFinancingArray[0].ddFinancingTerms);
        this.paymentType = this.productPayment.transactionType
      }

      if (this.productPayment.products.length > 0) {
        this._store.select(ProtectionProductStore).subscribe(data => {
          self.filteredProducts = [];
          this.dealers = data.items;
          if (this.dealers.dealers.length > 0) {
            for (var arr in this.productPayment.products) {
              for (var filter in this.dealers.dealers) {
                if (this.productPayment.products[arr].productId == this.dealers.dealers[filter].productId) {
                  this.productPayment.products[arr].imageURL = environment.PP_ENDPOINT + "/" + this.dealers.dealers[filter].imagePath;

                  let salesClassArray = this.dealers.dealers[filter].salesClasses.salesClass;
                  this.plan = [];

                  if (salesClassArray.length > 1) {
                    this.salesClass = salesClassArray.filter(function (item) {
                      return item.id == "New Vehicle";
                    });

                  }
                  else {
                    this.salesClass = salesClassArray;

                  }
                  if (this.salesClass.length > 0) {
                    this.productPayment.products[arr].productContent =(!isNil(this.salesClass[0].content) && !isNil(this.salesClass[0].content.productTaglineTextUrl))?this.salesClass[0].content.productTaglineTextUrl:"";
                    this.productPayment.products[arr].videoURL = (!isNil(this.salesClass[0].content) && !isNil(this.salesClass[0].content.productVideoUrl))?this.salesClass[0].content.productVideoUrl:"";
                  }
                  self.filteredProducts.push(this.productPayment.products[arr]);
                }
              }
            }
          }
        })
      }
      self.filteredProducts = this.removeDuplicates(self.filteredProducts);
    }


  }
  removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b)
  };
  getDealerDetails() {
    if (isNil(this.shared.dealerDetails)) {
      let dealerCd = this.dealerCd ? this.dealerCd : this.vehicle.dealerCd;
      if (!isNil(this.vehicle) && !isNil(dealerCd)) {
        this.dealerDetailService.getDealerDetails(dealerCd, 'filterOnly', 'full', 'JSON', environment.DIS_API_KEY)
          .subscribe((res => {
            this.dealerDetails = this.dealerDetailService.getFormattedDealerDetails(res);
            // console.log(this.dealerDetails);
            this.shared.dealerDetails = this.dealerDetails;
            this._store.dispatch(new SetSharedDataAction(this.shared));
            this.omTag.fireOmnitureTag('vp_aa-pageload', null, this.shared);
          }));
      }
    } else {
      this.dealerDetails = this.shared.dealerDetails;
      this.omTag.fireOmnitureTag('vp_aa-pageload', null, this.shared);
    }

  }
  //
  // ngOnDestroy
  //
  ngOnDestroy() {

  }


  //
  // Constructor
  //
  constructor(
    private _store: Store<IAppState>,
    private _route: ActivatedRoute,
    private _router: Router,
    public omTag: OmnitureTags,
    private dealerDetailService: DealerDetailService,
    private _ddMenuEnableDisableService: DDMenuEnableDisableService,
    public route: ActivatedRoute
  ) {

  }
  navigateToDetails(product,index) {
    let idObject = {
      "productId": product.productId,
      "planId": product.planId,
      "displayName": product.displayName,
      "timeMileage": product.timeMileage,
      "deductible": !isNil(product.deductible) ? product.deductible : "",
      "customerPrice": product.customerPrice,
      "monthlyPayment": product.monthlyPayment,
      "videoURL": product.videoURL,
      "index":index,
      "transactionType":this.paymentType
    }
    let part={
      'partNbr': product.planId,
      'marketingName':product.displayName
    }
    this.omTag.fireOmnitureTag('vp_aa-link', { url: product.imageURL, href: product.imageURL, text: 'view_details', trigger: 'aa-link', listIndex: index + 1, part: part }, this.shared);
    this.omTag.fireOmnitureTag('vp_aa-subpageload', { url: '', href: '', text: '', trigger: '', listIndex: '', part: part}, this.shared);
    this._router.navigate([`/v-spec/${this.vehicle.vin}/protectionproducts/detail`, idObject], { skipLocationChange: true });
  }

}
